import modals from '@/store/investments/modals'
import portfolios from '@/store/investments/portfolios'
import portfolio_dynamics from '@/store/investments/portfolio_dynamics'
import brokers from "@/store/investments/brokers"
import instruments from '@/store/investments/instruments'
import assets from '@/store/investments/assets'
import deals from '@/store/investments/deals'

export default {
    namespaced: true,
    modules: {
        modals,
        portfolios,
        brokers,
        portfolio_dynamics,
        instruments,
        assets,
        deals,
    }
}